import { TFunction } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";
import { CertStatusColors } from "../../constant/CertStatusColors";
import { ECertStatus } from "../../models/ICert";

const getTextProps = (t: TFunction) => ({
    certIsExpiring: t("Pätevyys on vanhentumassa"),
    certIsInvalid: t("Pätevyys ei ole voimassa"),
    certIsValid: t("Pätevyys on voimassa"),
    certCouldNotBeValidated: t("Pätevyyden voimassaoloa ei voitu määrittää")
});


export interface PersonCertStatusProps {
    status: ECertStatus;
};

export const PersonCertStatus: React.FC<PersonCertStatusProps> = ({ status }) => {
    const texts = getTextProps(useTranslation().t);

    const titleText = {
        [ECertStatus.Expires]: texts.certIsExpiring,
        [ECertStatus.NotValid]: texts.certIsInvalid,
        [ECertStatus.Valid]: texts.certIsValid,
        [ECertStatus.ValidationFailed]: texts.certCouldNotBeValidated
    }[status];

    return (
        <Icon
            name="circle"
            title={titleText}
            color={CertStatusColors[status]}
        />
    );
};

